import * as React from 'react';

import * as style from './styles.css';

export interface IAnswerListProps {
  children: React.ReactElement[];
  more: React.ReactNode;
}

export const AnswerList = (props: IAnswerListProps) => {
  const { children, more } = props;

  return (
    <div className={style['container']}>
      {children}
      <div className={style['more']}>{more}</div>
    </div>
  );
};
